var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},_vm._l((_vm.squares),function(square,index){return _c('div',{key:index,staticClass:"square",style:({
      width: _vm.squareSize + 'px',
      height: _vm.squareSize + 'px',
      backgroundColor: _vm.calculateColor(index),
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }